import React from "react"
import TextSection from "../TextSection"

class Technology extends React.Component {
  render() {
    return (
      <TextSection>
        <section>
          <h2>Teknologi</h2>
          {this.props.renderTechnology()}
        </section>
      </TextSection>
    )
  }
}

export default Technology



// WEBPACK FOOTER //
// ./src/components/CaseStudy/Technology/index.jsx